import { FC } from "react";
import {
	AccountTreeRounded as LogicalIcon,
	BuildCircleRounded as OperationalIcon,
	SvgIconComponent,
} from "@mui/icons-material";
import { Button, ButtonGroup } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigationPreferences } from "../../../hooks/usePreferences";
import { TransportPerspective } from "../../../state/preferences";

/**
 * The perspective selector internal button.
 * @param perspective the perspective linked to the button
 * @param icon the icon to be rendered before the button text
 * @constructor
 */
const SelectorButton: FC<{ perspective: TransportPerspective; icon: SvgIconComponent }> = ({
	perspective,
	icon: Icon,
}) => {
	const { t } = useTranslation("navigation");
	const { navigationPreferences: navigation, setNavigationPreferences } = useNavigationPreferences();

	const style =
		navigation.transportsPerspective === perspective ? "perspective-selected" : "perspective-not-selected";

	return (
		<Button
			className={style}
			startIcon={<Icon />}
			onClick={() => setNavigationPreferences({ transportsPerspective: perspective })}
		>
			{t(`navigation/perspective/${perspective}`)}
		</Button>
	);
};

/**
 * The perspective selector button (logical, operational).
 * Uses a shared state, which makes it easier for the user to navigate the application.
 *
 * @constructor
 */
export const TransportPerspectiveSelector: FC = () => {
	return (
		<ButtonGroup
			variant="contained"
			size="small"
			aria-label="perspective selector"
			sx={{ maxHeight: "40px", minHeight: "40px" }}
		>
			<SelectorButton perspective={"operational"} icon={OperationalIcon} />
			<SelectorButton perspective={"logical"} icon={LogicalIcon} />
		</ButtonGroup>
	);
};
